export const MODAL_DATA_ACTIONS = {
    SWITCH: 'modal switch',
    SET_FLAG: 'modal set flag',
    SET_DATA: 'modal set data',
    SET: 'modal set'
}
